import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';

import CircularProgress from '@mui/material/CircularProgress';

import Button from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';
import AttachmentIcon from '@mui/icons-material/Attachment';
import ImageIcon from '@mui/icons-material/Image';

import Tooltip from '@mui/material/Tooltip';

import { deepOrange, green } from '@mui/material/colors';


const styles = theme => ({
    root: {
        textAlign: 'center',
        margin: 5,
        padding: 10
    },
    button: {
        margin: theme.spacing(1, 1, 0, 0)
    },
    leftIcon: {
        marginRight: theme.spacing(1)
    },
    rightIcon: {
        marginLeft: theme.spacing(1)
    },
    iconSmall: {
        fontSize: 20
    },

    warningTooltip: {
        background: deepOrange[500]
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }
});







class Fichier extends React.Component {

    render() {
        let { fichier, classes, onClick, autorise, isDownloading, variant, color, size, label } = this.props;
        
        let PdfIcon = (
            <SvgIcon className={classNames(classes.leftIcon, classes.iconSmall)} style={{ width: '20px', height: '20px' }} viewBox="0 0 20 20" >
                <path d="M14,9H19.5L14,3.5V9M7,2H15L21,8V20A2,2 0 0,1 19,22H7C5.89,22 5,21.1 5,20V4A2,2 0 0,1 7,2M11.93,12.44C12.34,13.34 12.86,14.08 13.46,14.59L13.87,14.91C13,15.07 11.8,15.35 10.53,15.84V15.84L10.42,15.88L10.92,14.84C11.37,13.97 11.7,13.18 11.93,12.44M18.41,16.25C18.59,16.07 18.68,15.84 18.69,15.59C18.72,15.39 18.67,15.2 18.57,15.04C18.28,14.57 17.53,14.35 16.29,14.35L15,14.42L14.13,13.84C13.5,13.32 12.93,12.41 12.53,11.28L12.57,11.14C12.9,9.81 13.21,8.2 12.55,7.54C12.39,7.38 12.17,7.3 11.94,7.3H11.7C11.33,7.3 11,7.69 10.91,8.07C10.54,9.4 10.76,10.13 11.13,11.34V11.35C10.88,12.23 10.56,13.25 10.05,14.28L9.09,16.08L8.2,16.57C7,17.32 6.43,18.16 6.32,18.69C6.28,18.88 6.3,19.05 6.37,19.23L6.4,19.28L6.88,19.59L7.32,19.7C8.13,19.7 9.05,18.75 10.29,16.63L10.47,16.56C11.5,16.23 12.78,16 14.5,15.81C15.53,16.32 16.74,16.55 17.5,16.55C17.94,16.55 18.24,16.44 18.41,16.25M18,15.54L18.09,15.65C18.08,15.75 18.05,15.76 18,15.78H17.96L17.77,15.8C17.31,15.8 16.6,15.61 15.87,15.29C15.96,15.19 16,15.19 16.1,15.19C17.5,15.19 17.9,15.44 18,15.54M8.83,17C8.18,18.19 7.59,18.85 7.14,19C7.19,18.62 7.64,17.96 8.35,17.31L8.83,17M11.85,10.09C11.62,9.19 11.61,8.46 11.78,8.04L11.85,7.92L12,7.97C12.17,8.21 12.19,8.53 12.09,9.07L12.06,9.23L11.9,10.05L11.85,10.09Z" />
            </SvgIcon>
        );

        let SpreadSheetIcon = (
            <SvgIcon className={classNames(classes.leftIcon, classes.iconSmall)} style={{ width: '20px', height: '20px' }} viewBox="0 0 20 20" >
                <path d="M19,11V9H11V5H9V9H5V11H9V19H11V11H19M19,3C19.5,3 20,3.2 20.39,3.61C20.8,4 21,4.5 21,5V19C21,19.5 20.8,20 20.39,20.39C20,20.8 19.5,21 19,21H5C4.5,21 4,20.8 3.61,20.39C3.2,20 3,19.5 3,19V5C3,4.5 3.2,4 3.61,3.61C4,3.2 4.5,3 5,3H19Z" />
            </SvgIcon>
        );

        if (!fichier)
            return null;

        let extension = /[^.]+$/.exec(fichier.nom).toString().toLowerCase();
        
        let fichierNom = fichier.nom;
        if (fichierNom.length > 40) {
            fichierNom = fichierNom.substring(0, 20) + '...' + extension;
        }



        let CustomIcon = <AttachmentIcon className={classNames(classes.leftIcon, classes.iconSmall)} />;

        if (extension === 'pdf') {
            CustomIcon = PdfIcon;
        }
        if (extension === 'png' || extension === 'jpg' || extension === 'jpeg') {
            CustomIcon = <ImageIcon className={classNames(classes.leftIcon, classes.iconSmall)} />;
        }
        if (extension === 'xls' || extension === 'xlsx' || extension === 'csv') {
            CustomIcon = SpreadSheetIcon;
        }





        return (
        <React.Fragment>
            {autorise && (
                    <Button

                        variant={variant}
                        color={color}
                        size={size}

                        className={classes.button}
                        onClick={onClick}
                        disabled={isDownloading}
                    >
                    {CustomIcon}
                    {label ? label : fichierNom}
                    {isDownloading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </Button>
            )}
            {!autorise && (
                <Tooltip title="Vous n'avez pas les droits pour voir cette pièce jointe." classes={{ tooltip: classes.warningTooltip }}>
                    <Button variant="outlined" size="small" className={classes.button} >
                        {CustomIcon}
                        {fichierNom}
                    </Button>
                </Tooltip>
            )}
        </React.Fragment> 
        );
    }
}

Fichier.propTypes = ({
    classes: PropTypes.object.isRequired,

    fichier: PropTypes.object,
    autorise: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,

    variant: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,


});

export default withStyles(styles)(Fichier);